import { lazy } from "react"

export const NotificationSettings = lazy(() => import("./NotificationSettingsPage"))